import template from './app.html';
import controller from './app.controller';
import './app.scss';

let appComponent = {
  template,
  controllerAs: 'vm',
  controller
};

export default appComponent;



// WEBPACK FOOTER //
// ./client/app/app.component.js